import React from 'react'
import { Document } from './components/document'
import { Points } from './components/points';
import { Split } from './components/split';

export class Built extends React.Component {

    render() {
        return (
            <Split>
                <Document>
                    <h2>What is already built?</h2>
                    <p>We have spent the last 2.5 years building this platform from the ground up. The following things are already built:</p>
                    <Points>
                        {{ "points"     : [
                                {
                                    "header"      : "Complete API suite",
                                    "icon"        : "🔌",
                                    "description" : "Both inference and training endpoints in one platform"
                                },
                                {
                                    "header"      : "Continuous learning, continuous deployment", 
                                    "icon"        : "💪",
                                    "description" : "Your models stay live while training happens seamlessly in the background"
                                },
                                {
                                    "header"      : "Interactive playground",
                                    "icon"        : "🛝",
                                    "description" : "Perfect for prototyping and testing your agents"
                                },
                                {
                                    "header"      : "Zero technical complexity",
                                    "icon"        : "🚀",
                                    "description" : "No low-level ML expertise required"
                                },
                                {
                                    "header"      : "Scaling completed", 
                                    "icon"        : "📈",
                                    "description" : "Successfully transitioned to architecture supporting multiple concurrent users."
                                },
                                {
                                    "header"      : "Company Setup",
                                    "icon"        : "🏢",
                                    "description" : "Establishing the formal business structure and legal framework."
                                },
                                {
                                    "header"      : "Payment System",
                                    "icon"        : "💳",
                                    "description" : "Implementing robust payment processing and subscription management."
                                }
                        ]}}
                    </Points>
                </Document>
                <Document>
                    <h2>What remains</h2>
                    <p>With scaling completed, we're now focused on business operations and commercialization.</p>

                    <Points>
                        {{ "points"     : [
                                {
                                    "header"      : "Commercialization",
                                    "icon"        : "💵",
                                    "description" : "Taking the product to market and building our customer base."
                                },
                                {
                                    "header"      : "Getting financial backers",
                                    "icon"        : "💰",
                                    "description" : "Finding backers passionate about building a globally competitive AI platform from Oslo."
                                }
                        ]}}
                    </Points>
                </Document>
            </Split>
        );
    }
}

